import React from 'react';
import { BlogSubmenuDesktop, BlogSubmenuProps } from './BlogSubmenuDesktop';
import { BlogSubmenuMobile } from './BlogSubmenuMobile';

export const BlogSubmenu = (props: BlogSubmenuProps): JSX.Element => {
    return (
        <>
            <div className="mt-hidden">
                <BlogSubmenuDesktop {...props} />
            </div>
            <div className="d-hidden">
                <BlogSubmenuMobile {...props} />
            </div>
        </>
    );
};
